import React, { useState } from 'react';
import RadioButtonGroup from './RadioButtonGroup';
import { useTranslation } from 'react-i18next';
import FileUploader from './FileUploader';
import Button from './Button';
import MyText from './MyText';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useBusy } from '../context/BusyContext';
import { useApi } from '../context/ApiContext';
import { useSession } from '../context/SessionContext';

export default function StepAllegati() {
    const { setBusy } = useBusy();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { session, saveSession, clearSession } = useSession();
    const { getBufferId, setProfileInfo, setAllProfileInfo, setRelations,
        fieldsCV, fieldsLet, fieldsAltri } = useApi();
    const [state, setState] = useState({
        presentazione: null,
        cv: null,
        altriAllegati: null,
        trattamento: ''
    });
    const trattamentoOptions = [
        { key: '01', label: t('step3_trattamentoOption1') },
        { key: '02', label: t('step3_trattamentoOption2') },
    ]

    const getTodayDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const handleAllegatoChange = async (files, property, index) => {
        setState({
            ...state,
            [property]: files,
        });
    };

    const handleRadioChange = (x, property) => {
        setState({
            ...state,
            [property]: x,
        });
    }

    const handleBuffers = async () => {
        const newBuffers = [];
        const keys = ["cv", "presentazione", "altriAllegati"];

        for (const [index, key] of keys.entries()) {
            const files = state[key];
            newBuffers[index] = [];
            if (files){
                for (const file of files) {
                    const buffer = await getBufferId(file);
                    if (key !== "altriAllegati") {
                        newBuffers[index] = [buffer];
                    } else {
                        newBuffers[index].push(buffer);
                    }
                }
            }
        }
        return newBuffers;
    };

    const convertSessionKeysToUpper = (session) => {
        return Object.fromEntries(
            Object.entries(session).map(([key, value]) => [
                key[0].toUpperCase() + key.slice(1),
                value
            ])
        );
    }

    const insertSessionIntoFields = (fields, session, property) => {
        return fields.map(f => {
            if (f.externalId && session[f.externalId] !== undefined) {
                if (property === "cv") {
                }
                return { ...f, value: session[f.externalId] };
            }
            // per quelli che hanno externalId null
            if (f.name === "Originale") {
                // devo gestire il multi file
                return { ...f, value: state[property] ? state[property][0].name : "" }
            }
            if (f.name === "DataDoc") {
                return {...f, value: getTodayDate()}
            }
            return f;
        });
    }

    const insertDocnumberIntoFields = (fields, docnumberLet, docnumberDip) => {
        return fields.map(f => {
            if (f.externalId === "DocLettera") {
                return { ...f, value: [docnumberLet] }
            } else if (f.externalId === "DocDiplomi" && docnumberDip) {
                return { ...f, value: [docnumberDip] }
            }
            return f
        })
    }

    const isAllegatiComplete = () => {
        return state.presentazione && state.cv && state.trattamento;
    }

    const handleInvio = async () => {
        var bValid = isAllegatiComplete();
        if (!bValid) {
            toast.error(t('form_error'));
            return;
        }
        setBusy(true);
        try {
            const buffers = await handleBuffers();
            const uSession = convertSessionKeysToUpper({
                ...session,
                consensoAllaConservazione: state.trattamento === "01",
                eliminazioneDatiFineProcedura: state.trattamento === "02"
            });
            let newFieldsCV = insertSessionIntoFields(fieldsCV, uSession, "cv");
            const newFieldsLet = insertSessionIntoFields(fieldsLet, uSession, "presentazione");
            const newFieldsAltri = insertSessionIntoFields(fieldsAltri, uSession, "altriAllegati");
            const docnumberLet = await setProfileInfo(buffers[1], newFieldsLet);
            let docnumberDip = "";
            if (state.altriAllegati){
                docnumberDip = await setProfileInfo(buffers[2], newFieldsAltri);
            }
            // const [docnumberLet, docnumberDip] = await setAllProfileInfo(buffers, newFieldsLet, newFieldsAltri);
            newFieldsCV = insertDocnumberIntoFields(newFieldsCV, docnumberLet, docnumberDip);
            const docnumberCV = await setProfileInfo(buffers[0], newFieldsCV);
            await setRelations(docnumberCV, docnumberLet, docnumberDip);
            setBusy(false);
            clearSession();
            navigate("/Ringraziamento");
        } catch (error) {
            console.log("Errore:", error)
            toast.error(t('step3_invioError'));
            setBusy(false);
        }

    }

    return (
        <div style={styles.container}>
            <FileUploader label={t('step3_letteraLabel')} placeholder={t('step3_letteraPlaceholder')}
                onChange={(files) => handleAllegatoChange(files, "presentazione", 1)} />
            <FileUploader label={t('step3_cvLabel')} placeholder={t('step3_cvPlaceholder')}
                onChange={(files) => handleAllegatoChange(files, "cv", 0)} />
            <FileUploader multiple label={t('step3_allegatiLabel')} placeholder={t('step3_allegatiPlaceholder')}
                onChange={(files) => handleAllegatoChange(files, "altriAllegati", 2)} multi={true} />
            <div style={{ height: 0 }} />
            <RadioButtonGroup groupName={t('step3_trattamentoLabel')} options={trattamentoOptions}
                onChange={(x) => handleRadioChange(x, "trattamento")} />
            <div style={{ height: 0 }} />
            <div style={styles.buttonContainer}>
                <Button onClick={handleInvio}>
                    <MyText>{t('step3_buttonLabel')}</MyText>
                </Button>
            </div>
        </div>
    );
};
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 40,
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
    }
}